<template>
  <a-checkbox :checked="checked" @change="handleChange">
    <slot></slot>
  </a-checkbox>
</template>
<script>
import { eventTrack } from '@/apis/common'

export default {
  props: {
    checked: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    cmsId: String,
    description: String,
    pageName: String
  },
  emits: ['change'],
  methods: {
    async handleChange (e) {
      const isChecked = e.target.checked
      this.$emit('change', isChecked)

      try {
        await eventTrack({
          name: 'agreement_track',
          cms_id: this.cmsId,
          description: this.description,
          page_name: this.pageName,
          action: isChecked ? 'check' : 'uncheck'
        })
      } catch (err) {
        console.error('error：协议勾选记录失败')
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
